var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIco01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    enableBackground: "new 0 0 600 600",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    d: "M561.6,280.4V256l-59.8-9.2 c-2.2-13.7-5.8-26.9-10.6-39.6l47.2-37.8l-24.3-42.2l-56.4,22c-8.7-10.6-18.4-20.3-28.9-29l22-56.4l-42.2-24.4l-37.8,47.2 c-12.6-4.8-25.9-8.3-39.6-10.6l-9.2-59.8h-48.7l-9.2,59.8c-13.7,2.2-26.9,5.8-39.6,10.6l-37.8-47.2l-42.2,24.4l22,56.4 c-10.6,8.7-20.3,18.4-28.9,29l-56.4-22l-24.3,42.2l47.2,37.8c-4.8,12.6-8.3,25.9-10.6,39.6L33.5,256v24.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    d: "M234.2,280.4c0-35,28.4-63.3,63.3-63.3 c35,0,63.4,28.4,63.4,63.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    d: "M411.1,280.4c0-62.7-50.8-113.5-113.5-113.5 c-62.7,0-113.5,50.8-113.5,113.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    x1: 33.5,
    y1: 343.7,
    x2: 414.5,
    y2: 343.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    x1: 507.4,
    y1: 343.7,
    x2: 561.6,
    y2: 343.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    d: "M465.2,343.7 c0,14-11.4,25.3-25.3,25.3c-14,0-25.3-11.3-25.3-25.3c0-14,11.3-25.3,25.3-25.3C453.8,318.4,465.2,329.8,465.2,343.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    x1: 33.5,
    y1: 415.6,
    x2: 289.1,
    y2: 415.6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    x1: 382.1,
    y1: 415.6,
    x2: 561.6,
    y2: 415.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    d: "M339.8,415.6 c0,14-11.4,25.3-25.3,25.3c-14,0-25.3-11.3-25.3-25.3c0-14,11.4-25.3,25.3-25.3C328.5,390.2,339.8,401.6,339.8,415.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    x1: 33.5,
    y1: 487.4,
    x2: 85.6,
    y2: 487.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    x1: 178.6,
    y1: 487.4,
    x2: 561.6,
    y2: 487.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    d: "M136.3,487.4 c0,14-11.4,25.3-25.3,25.3c-14,0-25.3-11.3-25.3-25.3c0-14,11.4-25.3,25.3-25.3C125,462,136.3,473.4,136.3,487.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    x1: 33.5,
    y1: 559.2,
    x2: 246.2,
    y2: 559.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    x1: 339.1,
    y1: 559.2,
    x2: 561.6,
    y2: 559.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    d: "M296.9,559.2 c0,14-11.4,25.3-25.3,25.3c-14,0-25.3-11.3-25.3-25.3c0-14,11.3-25.3,25.3-25.3C285.5,533.9,296.9,545.2,296.9,559.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    d: "M530.2,133.1c-3.1-3.1-7.1-4.6-11.1-4.6H80.4 c-4,0-8,1.5-11.1,4.6c-3.1,3.1-4.6,7.1-4.6,11.1v284.4h90.6h288.8h90.6V144.2C534.8,140.2,533.3,136.2,530.2,133.1z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    points: "102.5,428.6 102.5,166.2 497.1,166.2  497.1,428.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    d: "M582.6,449.5c0,5.4-2,10.7-6.1,14.8 c-4.1,4.1-9.4,6.1-14.8,6.1H37.9c-5.4,0-10.7-2.1-14.8-6.1c-4.1-4.1-6.1-9.4-6.1-14.8v-20.9h565.6V449.5z"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    x1: 153.2,
    y1: 208.7,
    x2: 217.3,
    y2: 208.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    x1: 217.3,
    y1: 275.8,
    x2: 286.3,
    y2: 275.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    x1: 217.3,
    y1: 376.3,
    x2: 286.3,
    y2: 376.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    x1: 153.2,
    y1: 242.2,
    x2: 286.3,
    y2: 242.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    x1: 153.2,
    y1: 309.3,
    x2: 217.3,
    y2: 309.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    x1: 153.2,
    y1: 342.8,
    x2: 286.3,
    y2: 342.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    x1: 313.3,
    y1: 275.8,
    x2: 446.4,
    y2: 275.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    x1: 313.3,
    y1: 376.3,
    x2: 446.4,
    y2: 376.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    x1: 313.3,
    y1: 242.2,
    x2: 382.3,
    y2: 242.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#181818",
    strokeWidth: 19,
    strokeMiterlimit: 10,
    x1: 313.3,
    y1: 342.8,
    x2: 382.3,
    y2: 342.8
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 239.9,
    fill: "#181818",
    width: 19.5,
    height: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.6,
    y: 204.7,
    fill: "#181818",
    width: 19.5,
    height: 59.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.3,
    y: 219.9,
    fill: "#181818",
    width: 19.5,
    height: 43.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.9,
    y: 175.6,
    fill: "#181818",
    width: 19.5,
    height: 88.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.5,
    y: 188,
    fill: "#181818",
    width: 19.5,
    height: 75.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.1,
    y: 127.2,
    fill: "#181818",
    width: 19.5,
    height: 136.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.7,
    y: 150.8,
    fill: "#181818",
    width: 19.5,
    height: 113
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 344.2,
    y: 408.8,
    fill: "#181818",
    width: 116,
    height: 19.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.2,
    y: 448.3,
    fill: "#181818",
    width: 116,
    height: 19.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 408.8,
    fill: "#181818",
    width: 116.1,
    height: 19.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 448.3,
    fill: "#181818",
    width: 116.1,
    height: 19.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.2,
    y: 369.2,
    fill: "#181818",
    width: 116,
    height: 19.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 369.2,
    fill: "#181818",
    width: 116.1,
    height: 19.5
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M460.2,351.8H203v-71.5h257.2V351.8z M222.5,332.3h218.2v-32.5H222.5V332.3z"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M519.5,521.3H143.8V72.6h375.7V521.3z M163.3,501.8H500V92.1H163.3V501.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M519.5,92.1H143.8V9.4h375.7V92.1z M163.3,72.6H500V28.9H163.3V72.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 40.6,
    fill: "#181818",
    width: 19.5,
    height: 19.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 40.6,
    fill: "#181818",
    width: 19.5,
    height: 19.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.1,
    y: 40.6,
    fill: "#181818",
    width: 19.5,
    height: 19.5
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#181818",
    points: "448.2,592.6 72.5,592.6 72.5,153.6 92,153.6 92,573.1 428.7,573.1 428.7,540.9 448.2,540.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#181818",
    points: "124.2,163.4 72.5,163.4 72.5,80.7 124.2,80.7 124.2,100.2 92,100.2 92,143.9 124.2,143.9  "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#181818",
    points: "385.7,588.8 212.6,588.8 212.6,531.4 232.1,531.4 232.1,569.2 366.2,569.2 366.2,531.4  385.7,531.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.5,
    y: 569.2,
    fill: "#181818",
    width: 241.2,
    height: 19.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M570,449.3H28.3V104.2c0-7.5,2.9-14.6,8.3-19.9c5.3-5.3,12.4-8.3,20-8.3h96.9v19.6H56.5 c-2.3,0-4.5,0.9-6.1,2.5c-1.6,1.6-2.5,3.8-2.5,6.1v325.6h502.6V104.2c0-2.3-0.9-4.4-2.6-6.1c-1.6-1.6-3.8-2.5-6-2.5h-96.9V76h96.9 c7.6,0,14.6,2.9,19.9,8.3c5.3,5.3,8.3,12.4,8.3,19.9V449.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M541.8,510.7H56.5c-7.6,0-14.7-2.9-20-8.3c-5.3-5.3-8.2-12.4-8.2-19.9v-52.8H570v52.8c0,7.6-3,14.7-8.3,20 C556.5,507.8,549.4,510.7,541.8,510.7z M47.8,449.3v33.2c0,2.3,0.9,4.5,2.5,6.1c1.6,1.7,3.8,2.5,6.1,2.5h485.4 c2.3,0,4.5-0.9,6-2.5c1.7-1.7,2.6-3.8,2.6-6.1v-33.2H47.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#181818",
    points: "526.5,405.8 71.8,405.8 71.8,119.5 153.4,119.5 153.4,139.1 91.4,139.1 91.4,386.2 507,386.2  507,139.1 444.9,139.1 444.9,119.5 526.5,119.5  "
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#181818",
    points: "454.7,396 435.1,396 435.1,89.8 376,30.7 163.2,30.7 163.2,396 143.6,396 143.6,11.1 384.1,11.1  454.7,81.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#181818",
    points: "444.9,95.5 370.3,95.5 370.3,20.9 389.9,20.9 389.9,76 444.9,76  "
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 283.8,
    y: 294.7,
    fill: "#181818",
    width: 113.1,
    height: 19.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.8,
    y: 329.5,
    fill: "#181818",
    width: 113.1,
    height: 19.6
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#181818",
    points: "223.4,347.7 194.5,318.8 208.3,304.9 223.4,320 251.3,292.1 265.1,306  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 283.8,
    y: 216.4,
    fill: "#181818",
    width: 113.1,
    height: 19.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.8,
    y: 251.2,
    fill: "#181818",
    width: 113.1,
    height: 19.6
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#181818",
    points: "223.4,269.4 194.5,240.4 208.3,226.6 223.4,241.7 251.3,213.8 265.1,227.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 283.8,
    y: 138.1,
    fill: "#181818",
    width: 113.1,
    height: 19.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.8,
    y: 172.9,
    fill: "#181818",
    width: 113.1,
    height: 19.6
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#181818",
    points: "223.4,191.1 194.5,162.1 208.3,148.3 223.4,163.4 251.3,135.5 265.1,149.3  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco01);
export default __webpack_public_path__ + "static/media/ico_01.a4f2bbae120e7a970a9d08821e140173.svg";
export { ForwardRef as ReactComponent };